export var CareSendEncryptionError;
(function (CareSendEncryptionError) {
    CareSendEncryptionError["CORRUPTED_DATA"] = "Corrupted data";
    CareSendEncryptionError["PERMISSION_DENIED"] = "This data is not viewable by you";
})(CareSendEncryptionError || (CareSendEncryptionError = {}));
//# sourceMappingURL=encryption.js.map